import React, {useEffect, useMemo, useState} from "react";
import { useLanguages } from "../../../hooks/content";
import "./termsAndConditionsPhysical.scss";
import axios from "axios";
import {useLocation, useNavigate} from "react-router-dom";

function TermsAndConditionsPhysical() {
    const { lang } = useLanguages();
    const navigate = useNavigate();
    const search = useLocation().search;
    const token = useMemo(() => new URLSearchParams(search).get("token"), [search]);

    const [loading, setLoading] = useState(true);
    const [payload, setPayload] = useState(null);
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [adsAccepted, setAdsAccepted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState(null);

    useEffect(() => {
        if (!token) {
            navigate('/');
            return;
        }
        axios.get(`${process.env.REACT_APP_API_URL}/terms-physical`)
            .then((res) => {
                setPayload(res.data);
                setLoading(false)
            }).catch((err) => {
            console.error(err);
            navigate('/');
        });
    }, [])

    const handleAccept = () => {
        if (!termsAccepted || submitting || !token) return;
        setSubmitting(true);
        setSubmitError(null);
        axios.post(`${process.env.REACT_APP_API_URL}/terms-physical/accept`, {
            token,
            language: lang === 'ka' ? 'ka' : 'en',
            accept_ads_policy: adsAccepted,
        }).then(() => {
            navigate('/');
        }).catch((err) => {
            console.error(err);
            setSubmitError(
                lang === 'ka'
                    ? 'დადასტურება ვერ მოხერხდა, სცადეთ თავიდან.'
                    : 'Could not confirm, please try again.'
            );
            setSubmitting(false);
        });
    };

    if (loading || !payload) return <div></div>

    return (
        <div>
            <div className="terms_conditions">
                <div className="gz-icon">
                    <img src="/images/icons/gz-lg.png" alt="gz_icon" />
                </div>
            </div>
            <div className="cont1">
                <div
                    className="wrap"
                    dangerouslySetInnerHTML={{ __html: lang === 'ka' ? payload?.ka : payload?.en }}
                />
            </div>
            <div className="terms_checkboxes">
                <label className="terms_checkbox">
                    <input
                        type="checkbox"
                        checked={termsAccepted}
                        onChange={(e) => setTermsAccepted(e.target.checked)}
                    />
                    <span>
                       <span>
                        By registering, you accept that you are 18 or older and agree with terms and conditions.
                    </span>
                    </span>
                </label>
                <label className="terms_checkbox">
                    <input
                        type="checkbox"
                        checked={adsAccepted}
                        onChange={(e) => setAdsAccepted(e.target.checked)}
                    />
                    <span>
                        By registering, you accept that you agree to receive ads from gzavnili.
                    </span>
                </label>
                {submitError && (
                    <div className="terms_error">{submitError}</div>
                )}
                <button
                    type="button"
                    className="terms_submit"
                    disabled={!termsAccepted || submitting}
                    onClick={handleAccept}
                >
                    {submitting
                        ? (lang === 'ka' ? 'იტვირთება...' : 'Submitting...')
                        : 'დადასტურება'}
                </button>
            </div>
        </div>
    );
}

export default TermsAndConditionsPhysical;
